import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type ReactRendererService from 'garaje/services/react-renderer';
import type StateService from 'garaje/services/state';
import type { Root } from 'react-dom/client';

export default class VisitorProfilesIndexController extends Controller {
  @service declare flashMessages: FlashMessagesService;
  @service declare reactRenderer: ReactRendererService;
  @service declare router: RouterService;
  @service declare state: StateService;

  private root?: Root;

  @action
  handleNavigate(route: string, ...args: unknown[]): void {
    // @ts-expect-error - Bridging React navigation to Ember router with dynamic route args
    this.router.transitionTo(route, ...args);
  }

  @action
  showMergeSuccessFlash(): void {
    this.flashMessages.showAndHideFlash('success', 'Visitor Profiles merged');
  }

  @action
  async injectComponent(): Promise<void> {
    const { VisitorProfileView } = await import('reactRichComponents/visitors/profiles/VisitorProfileView');
    if (this.isDestroying || this.isDestroyed) return;

    this.root = await this.reactRenderer.render(VisitorProfileView, 'react__visitor-profiles-directory-view', {
      companyId: this.state.currentCompany.id,
      locationId: this.state.currentLocation.id,
      onNavigate: (route, ...args) => this.handleNavigate(route, ...args),
      onMergeSuccess: () => this.showMergeSuccessFlash(),
    });
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
